module.exports = __webpack_public_path__ + "static/media/state.e30ed997.svg";